<template>
    <v-container fluid class="pr-0 pl-0">
        <h2><TranslatableStringComponent :tstring="{string: 'coupon'}" /></h2>
        <v-row column justify-center align-center>
            <v-col cols="12">
                <v-card class="">
                    <v-card-actions>
                        <div style="display:flex">
                            <v-text-field
                                v-model="coupon"
                                outlined
                                :readonly="isCouponChecked"
                                dense
                                hide-details
                                :placeholder="localize('enterCouponCode')"
                                class="mr-5"
                            ></v-text-field>
                            <v-btn
                                v-if="isCouponChecked"
                                dense
                                color="primary"
                                outlined
                                @click.prevent="removeCoupon()"
                                ><TranslatableStringComponent :tstring="{string: 'remove'}" /></v-btn
                            >
                            <v-btn
                                v-else
                                dense
                                color="primary"
                                :loading="loader"
                                @click.prevent="checkCouponExist()"
                                ><TranslatableStringComponent :tstring="{string: 'applyCoupon'}" /></v-btn
                            >
                        </div>
                    </v-card-actions>
                    <div
                        v-if="discountValue > 0"
                        class="success-color pl-2 pb-1"
                    >
                        <fa :icon="['fal', 'tag']" class="fa-lg" />
                        <i>{{ fetchSuccessMsg }}</i>
                    </div>
                    <div
                        v-else-if="fetchCouponError"
                        class="error-color pl-2 pb-1"
                    >
                        <i>* {{ fetchCouponError }} </i>
                    </div>
                </v-card>
                <div
                    v-if="
                        categoriesExcluded.length > 0 &&
                            cartItemsExcluded.length > 0
                    "
                    class="mt-3"
                >
                    <v-alert
                        dense
                        outlined
                        type="info"
                        color="#0063a6"
                        class="body-2"
                    >
                        <p class="mb-0">
                            <TranslatableStringComponent :tstring="{string: 'couponDoesNotApplyToTheseItems'}" />
                            :
                        </p>
                        <ul>
                            <li
                                v-for="item in cartItemsExcluded"
                                :key="item._id"
                            >
                                {{ item.pn }} (<i> {{ item.name_en }} </i>)
                            </li>
                        </ul>
                    </v-alert>
                </div>
                <div
                    v-if="
                        categoriesIncluded.length > 0 &&
                            cartItemsIncluded.length > 0 &&
                            fetchCartProducts.length > cartItemsIncluded.length
                    "
                    class="mt-3"
                >
                    <v-alert
                        dense
                        outlined
                        type="info"
                        color="#0063a6"
                        class="body-2"
                    >
                        <p class="mb-0">
                            <TranslatableStringComponent :tstring="{string: 'couponOnlyAppliesTo'}" />
                        </p>
                        <ul class="mb-0">
                            <li
                                v-for="item in cartItemsIncluded"
                                :key="item._id"
                            >
                                {{ item.name_en }}
                            </li>
                        </ul>
                    </v-alert>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue' 
export default {
    name: 'Coupon',
    components: {
        TranslatableStringComponent,
    },
    data() {
        return {
            // coupon: ''
        }
    },
    computed: {
        ...mapGetters({
            fetchCouponError: 'coupon/fetchCouponError',
            discountValue: 'coupon/discountValue',
            fetchSuccessMsg: 'coupon/fetchSuccessMsg',
            cartItemsExcluded: 'coupon/cartItemsExcluded',
            cartItemsIncluded: 'coupon/cartItemsIncluded',
            categoriesIncluded: 'coupon/categoriesIncluded',
            categoriesExcluded: 'coupon/categoriesExcluded',
            fetchCartProducts: 'cart/fetchCartProducts'
        }),
        ...mapState('coupon', ['loader', 'couponObj', 'isCouponChecked']),
        coupon: {
            get() {
                return this.$store.state.coupon.couponCode
            },
            set(v) {
                this.$store.commit('coupon/setCouponCode', v)
            }
        }
    },
    methods: {
        ...mapActions('coupon', ['removeCoupon']),
        checkCouponExist() {
            this.coupon &&
                this.$store.dispatch(
                    'coupon/checkCouponExist',
                    this.coupon.toUpperCase()
                )
        }
    }
}
</script>
